<mat-expansion-panel #panel class="expansion-panel-review" hideToggle>
    <mat-expansion-panel-header>
        <div class="field-name">
            <div class="card-title">
                {{ 'POSITION.PANORAMA_COMPETENCIES' | translate }}
            </div>
        </div>
        <div class="card-actions">
            <button mat-flat-button color="primary" class="review-button bt-long-text">
                <mat-icon *ngIf="!panel.expanded" >keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="panel.expanded">keyboard_arrow_up</mat-icon>
                {{ 'POSITION.DETAILS' | translate }}
            </button>
        </div>
    </mat-expansion-panel-header>
    <div></div>
</mat-expansion-panel>
